// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "total-UFst4";
var _3 = "totalTitle-3eOmI";
var _4 = "money-HqXJT";
var _5 = "row-3vrY3";
export { _1 as "__esModule", _2 as "total", _3 as "totalTitle", _4 as "money", _5 as "row" }
export default { "__esModule": _1, "total": _2, "totalTitle": _3, "money": _4, "row": _5 }
